module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "block__width-1200",
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.is_loaded),
      expression: "is_loaded"
    }]
  }, [_c('sHeader'), _vm._v(" "), _c('router-view', {
    on: {
      "pageStatus": _vm.pageLoader
    }
  }), _vm._v(" "), _c('sFooter')], 1)]), _vm._v(" "), (!_vm.is_loaded) ? _c('div', {
    staticClass: "ic_loader"
  }, [_c('img', {
    attrs: {
      "src": require("./assets/images/an_loader.gif")
    }
  })]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-525c515e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 326
// module chunks = 1